import React, { FC, useState } from 'react'
import { Divider } from 'antd'
// import { useGeneratorData } from '../../hooks/useGeneratorData'
// import { PowerTypeTag } from '../'
// import { Link } from 'react-router-dom'
import style from './style.m.less'
import { ShowMoreLink, PowerTypeTag } from '../../../ui'
import { Link } from 'react-router-dom'

interface IInfoBlock {
    name?: string
    value?: string
    isTag?: boolean
    isOwner?: boolean
    isDivider?: boolean
    noMargin?: boolean
    visible?: boolean
    href?: string
}

interface IGeneratorInfoFrame {
    label: string
    statusBlock: React.ReactNode
    config: {
        visibleInfo: IInfoBlock[]
        hiddenInfo?: IInfoBlock[]
    }
    isProfile?: boolean
    customStyle?: React.CSSProperties
    bottomChildren?: React.ReactNode
}

const createInfoBlocks = (config: IInfoBlock[], isVisible?: boolean) => {
    return config?.map((item, index) => {
        const { name, value, isTag, isDivider, noMargin, href } = item

        const chooseBlockClass = () => {
            if (index === 0 && isVisible && !noMargin) {
                return style.infoBlockFirst
            } else if (noMargin) {
                return style.infoBlockNoMargin
            } else {
                return style.infoBlock
            }
        }

        const chooseBlockType = () => {
            if (isTag && value) {
                return (
                    <PowerTypeTag value={value} customStyle={{ marginLeft: '24px' }}>
                        {value}
                    </PowerTypeTag>
                )
            } else if (href) {
                return (
                    <Link to={href} className={style.infoValueLink}>
                        {value}
                    </Link>
                )
            } else if (isDivider) {
                return <Divider />
            } else {
                return <div className={style.infoValue}>{value}</div>
            }
        }

        return (
            <React.Fragment key={name}>
                {Boolean(value) && (
                    <div className={chooseBlockClass()}>
                        <div className={style.infoName}>{name}</div>
                        {chooseBlockType()}
                    </div>
                )}
            </React.Fragment>
        )
    })
}

const GeneratorInfoFrame: FC<IGeneratorInfoFrame> = ({
    label,
    statusBlock,
    config,
    customStyle,
    children,
    bottomChildren,
}) => {
    const [showHidden, setShowHidden] = useState(false)

    const toggleHidden = () => {
        setShowHidden(!showHidden)
    }
    const { visibleInfo, hiddenInfo } = config
    const hasHiddenInfoVisibleItem = hiddenInfo?.some((item) => Boolean(item.value) === true)

    return (
        <div className={style.generatorInfoFrameMain} style={customStyle}>
            <div className={style.headerPrimary}>{label}</div>
            {children}
            {statusBlock}
            {createInfoBlocks(visibleInfo, true)}
            {!showHidden && hiddenInfo && hasHiddenInfoVisibleItem && (
                <ShowMoreLink showMore={false} onChange={toggleHidden} />
            )}
            {showHidden && hiddenInfo && (
                <>
                    <Divider />
                    {createInfoBlocks(hiddenInfo)}
                    <ShowMoreLink showMore onChange={toggleHidden} />
                </>
            )}
            {bottomChildren && bottomChildren}
        </div>
    )
}

export default GeneratorInfoFrame
